'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var locale = {
    placeholder: 'Chọn thời gian'
};
exports["default"] = locale;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/time-picker/locale/vi_VN.tsx
 ** module id = 807
 ** module chunks = 1
 **/